"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EstrutuiraEQualidade() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="estrutura-e-qualidade" ref={ref} className="bg-background py-40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div className={`transform transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
            <div className="border border-[hsl(0,0%,90%)]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/podcast_setup_quality.png" alt="Technical podcast setup with microphones and soundproofing" className="h-auto w-full object-cover" />
            </div>
          </div>

          {}
          <div className={`flex flex-col justify-center transform transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
            <h2 className="font-default text-4xl font-bold text-foreground mb-8">Por que escolher a ITC+ em Pinheiros</h2>

            <div className="space-y-6">
              <p className="text-base leading-relaxed" style={{
              color: "hsl(0, 0%, 35%)"
            }}>A ITC+ é mais do que um estúdio de podcast em Pinheiros. Somos uma produtora que une estrutura profissional, direção estratégica e foco em resultado.</p>

              <p className="text-base leading-relaxed" style={{
              color: "hsl(0, 0%, 35%)"
            }}>Nosso estúdio está localizado na zona oeste de São Paulo, próximo à Faria Lima, facilitando o acesso para empresas, especialistas e criadores que precisam de agilidade e praticidade na produção de conteúdo.</p>

              <p className="text-base leading-relaxed" style={{
              color: "hsl(0, 0%, 35%)"
            }}>Mais do que um espaço, entregamos direção e produção para que seu conteúdo tenha impacto e posicionamento.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}